import { useMissionsTranslation } from '../../../../ui/hooks';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Box, Typography } from '@mui/material';
import React from 'react';
export const ParticipantInfoCard = ({ shiftAttendanceAnalytics }) => {
    const { t } = useMissionsTranslation();
    const { checkedInParticipantsCount, checkedOutParticipantsCount, notCheckedInParticipantsCount } = shiftAttendanceAnalytics;
    const rows = [
        { label: t('common.empty'), value: notCheckedInParticipantsCount },
        { label: t('common.checkIn'), value: checkedInParticipantsCount },
        { label: t('common.checkOut'), value: checkedOutParticipantsCount },
    ];
    return (React.createElement(Box, { width: '100%', sx: { backgroundColor: themeColors.surface.secondary, p: 2, borderRadius: '4px' } },
        React.createElement(Box, { component: 'dl', sx: {
                display: 'grid',
                gridTemplateColumns: 'auto 1fr',
                rowGap: 1,
                columnGap: 6,
                alignItems: 'center',
                m: 0,
            } }, rows.map(({ label, value }) => (React.createElement(React.Fragment, { key: label },
            React.createElement(Typography, { component: 'dt', variant: 'body2', color: themeColors.text.subtle, sx: { m: 0 } }, label),
            React.createElement(Typography, { component: 'dd', variant: 'body2', sx: { m: 0 } },
                value,
                " ",
                t('common.volunteers'))))))));
};
